import React from "react";
import PropTypes from "prop-types";

import { Heading, Link, ColumnBreak } from '@menu/components';

const components = {
  'heading': Heading,
  'link': Link,
  'column break': ColumnBreak,
}

const MenuItem = (props) => {
  
  let key = props.item.kind || 'column break';

  if (key in components) {
    const Component = components[key];
    return (
      <li className={`${key}-wrapper`}>
        <Component item={props.item} active={props.active} />
      </li>
    );
  }

  return <ColumnBreak />
}

MenuItem.propTypes = {
  item: PropTypes.any,
  active: PropTypes.bool.isRequired
}

export default MenuItem;
